module.exports = [
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2000",
    "Rate": 417.07
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2002-2004",
    "Rate": 413.53
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2005-2007",
    "Rate": 408.33
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2010",
    "Rate": 343.5
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2011-2013",
    "Rate": 343.2
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2014-2016",
    "Rate": 381.73
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "Black, not Hispanic",
    "Year": "2018",
    "Rate": 427.75
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2000",
    "Rate": 235.17
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2002-2004",
    "Rate": 252.7
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2005-2007",
    "Rate": 260.9
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2010",
    "Rate": 218.13
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2011-2013",
    "Rate": 232.7
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2014-2016",
    "Rate": 217.1
  },
  {
    "AgeGroup": "35-44 years",
    "Race": "White, not Hispanic",
    "Year": "2018",
    "Rate": 249.2
  }
]
